<template>
    <div class="editClass">
        <div class="tableClass">
            <el-table
                :data="tableData"
                style="width: 100%"
                border
                :header-cell-style="{ background: '#f5f7fa' }"
            >
                <el-table-column v-for="col in columns" :key="col.prop" :prop="col.prop" :label="col.label" min-width="160" align="center">
                    <template slot-scope="scope">
                        <div class="nameClass">
                            <el-button class="uploadClass" v-if="col.prop == 'operate'" @click="deleteClick(scope.row.id)">删除</el-button>
                            <el-input v-else-if="col.prop == 'phone'" v-model="scope.row[col.prop]" maxlength="11" clearable></el-input>
                            <el-input v-else v-model="scope.row[col.prop]" clearable></el-input>

                            <template v-if="col.prop == 'phone'">
                                <div v-if="col.is_required && !isValidPhoneNumber(scope.row[col.prop])" class="tipsClass" >
                                    手机号格式不正确
                                </div>
                            </template>
                            <template v-else>
                                <div v-if="scope.row[col.prop] == '' && col.is_required" class="tipsClass">
                                    请填写内容
                                </div>
                            </template>
                        </div>
                    </template>                    
                </el-table-column>
            </el-table>
        </div>
        <el-button class="uploadClass" @click="uploadClick">提交</el-button>
    </div>
</template>

<script>
export default {
    data(){
        return{
            // 表头
            columns: [
                { prop: 'id', label: '序号' },
                { prop: 'name', label: '姓名', is_required: true},
                { prop: 'birthday', label: '生日' },
                { prop: 'phone', label: '电话', is_required: true },
                { prop: 'residence', label: '常居地' },
                { prop: 'speakingExamTime', label: '口语考试时间' },
                { prop: 'operate', label: '操作'}
            ],
            // 表格数据
            tableData: [
                {
                    id: '1',
                    name: '蒋若雯',
                    birthday: '2002.2.15',
                    phone: '13771428680',
                    residence: '江苏无锡',
                    speakingExamTime: '8:20',
                },
                {
                    id: '2',
                    name: '王楚妍',
                    birthday: '2000.8.6',
                    phone: '',
                    residence: '',
                    speakingExamTime: '9:00'
                },
                {
                    id: '3',
                    name: 'Chen Jing Nan',
                    birthday: '',
                    phone: '18186885087',
                    residence: '',
                    speakingExamTime: ''
                },
                {
                    id: '4',
                    name: 'Su Ding wen',
                    birthday: '',
                    phone: '',
                    residence: '',
                    speakingExamTime: ''
                }
            ]
        }
    },
    methods:{
        uploadClick(){
            let phoneErrorList = []
            let nameErrorList = []

            this.tableData.forEach((item, index) => {
                // 手机号校验
                if(!this.isValidPhoneNumber(item.phone)){
                    phoneErrorList.push(1)
                }
                // 姓名非空检验
                if(item.name == ''){
                    nameErrorList.push(1)
                }
            });

            if(phoneErrorList.length > 0){
                this.$message({
                    message: '手机号格式不正确',
                    type: 'warning'
                });
                return
            }
            if(nameErrorList.length > 0){
                this.$message({
                    message: '请填写姓名',
                    type: 'warning'
                });
                return
            }

            console.log('phoneErrorList', phoneErrorList)
            console.log('提交的数组', this.tableData)
        },
        deleteClick(item){
            console.log(item)
            let index = this.tableData.findIndex(obj => obj.id == item)
            if (index != -1){
                this.tableData.splice(index, 1)
            }
        },

        // 手机号校验
        isValidPhoneNumber(phoneNumber){
            // 中国大陆手机号码正则表达式
            const regex = /^1[3-9]\d{9}$/;
            return regex.test(phoneNumber);
        }
    }
}
</script>

<style lang="scss" scoped>
.editClass{
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    background-color: rgb(194, 235, 251);
}
.tableClass{
    margin: 100px auto 0;
}
.nameClass{
    // background-color: aquamarine;
}
.uploadClass{
    margin: 20px auto;
    width: 100px;
}
.tipsClass{
    // margin-top: 10px;
    color: #f56c6c;
    font-size: 14px;
}

</style>